module.exports = __webpack_public_path__ + "img/dias.ae3f6f88.jpg";